import { NgClass, NgFor, NgIf, SlicePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { InputErrorDirective } from '../../directives/input-error.directive';
import { difference, intersection, uniq, groupBy } from 'underscore';
import { IOrgStandard } from 'src/app/services/org-frameworks.service';

@Component({
    imports: [NgIf, NgSelectModule, FormsModule, ReactiveFormsModule, SlicePipe, NgFor, InputErrorDirective, NgClass],
    selector: 'app-customised-multi-select-for-org-capabilities',
    templateUrl: 'customised-multi-select-for-org-capabilities.component.html'
})

export class CustomisedMultiSelectForOrgCapabilitiesComponent implements OnChanges {
    @ViewChild('selector') selector: NgSelectComponent;
    @Input() items: any[];
    @Input() name: string;
    @Input() id: string;
    @Input() bindLabel: string;
    @Input() bindValue: string;
    @Input() ngModelValue: any[];
    @Input() showError = false;
    @Input() searchFn;
    @Input() groupByValue = '';
    @Output() ngModelValueChange = new EventEmitter();
    @Input() control: FormControl;
    @Input({ required: true }) valueMode: 'ngModel' | 'formControl';
    filteredItems: any[];
    capabilityList: any[];
    frameworkGroupedList: any;

    ngOnChanges() {
      if(this.items){
        const frameworkGroupedList = groupBy(this.items, 'frameworkID');
        for(let frameworkID in frameworkGroupedList){
          frameworkGroupedList[frameworkID] = frameworkGroupedList[frameworkID].filter(i => !(i.parentStandardID && i.parentStandard)).map(c => c.standardID)
          .map(capabilityID => {
            return this.items.filter(i => i.standardID === capabilityID || i.parentStandardID === capabilityID);
          });
        }
        this.frameworkGroupedList = frameworkGroupedList;
      }

    }

    changeNgModelValue(e) {
        this.ngModelValueChange.emit(e);
    }

    onSelectAll() {
        const selected = (this.filteredItems || this.items).map(item => item[this.bindValue]);
        this.ngModelValue = selected;
        this.ngModelValueChange.emit(this.ngModelValue);
        this.filteredItems = null;
        if (this.selector) { this.selector.close(); }
    }

    onClearAll() {
        this.ngModelValue = [];
        this.ngModelValueChange.emit(this.ngModelValue);
    }


    getFilteredItems(e) {
        this.filteredItems = e.items;
    }

    getPrefix(item) {
      const capabilityList = this.frameworkGroupedList[item.frameworkID];
      if(item.parentStandardID && item.parentStandard){
        const capabilityIndex = capabilityList.findIndex(c => c[0]?.standardID === item.parentStandardID);
        const skillOrder = capabilityList[capabilityIndex].findIndex(s => s.standardID === item.standardID);
        return `Skill ${capabilityIndex + 1}.${skillOrder}: ${item.name}`;
      } else {
        const capabilityIndex = capabilityList.findIndex(c => c[0]?.standardID === item.standardID);
        return `Capability ${capabilityIndex + 1}: ${item.name}`;
      }
    }

    onClearAllStandards() {
        this.control.patchValue('');
    }

    getEnabledStandards(standards: IOrgStandard[]): IOrgStandard[] {
        return standards.filter(standard => !!standard);
    }

    addAnItem(standard: IOrgStandard) {
        // select parent standard while skill selected
        if (standard.parentStandardID && standard.parentStandard) {
            if (this.valueMode === 'ngModel' && !this.ngModelValue.find(s => s.standardID === standard.parentStandardID)) {
                this.ngModelValue = uniq([...this.ngModelValue, standard.parentStandard.standardID]);
                this.ngModelValueChange.emit(this.ngModelValue);
            }
            if (this.valueMode === 'formControl' && !this.control.value.find(s => s.standardID === standard.parentStandardID)) {
                this.control.patchValue(uniq([...this.control.value, standard.parentStandard.standardID]));
            }
        }
    }

    removeAnItem(standard: IOrgStandard) {
        // deselect child skills when standard deselected
        if (standard.standardType === 'standard') {
            if (this.valueMode === 'ngModel' && intersection(this.ngModelValue, this.items.filter(s => s.parentStandardID === standard.standardID).map(s => s.standardID)).length > 0) {
                const skills = (this.items.filter(s => s.parentStandardID === standard.standardID) || []);
                const tempFormValue = [...this.ngModelValue];
                this.ngModelValue = [...difference(tempFormValue, skills.map(g => g.standardID))];
                this.ngModelValueChange.emit(this.ngModelValue);
            }
            if (this.valueMode === 'formControl' && intersection(this.control.value, this.items.filter(s => s.parentStandardID === standard.standardID).map(s => s.standardID)).length > 0) {
                const skills = (this.items.filter(s => s.parentStandardID === standard.standardID) || []);
                const tempFormValue = [...this.control.value];
                this.control.patchValue([...difference(tempFormValue, skills.map(s => s.standardID))]);
            }
        }
    }
}
